<template enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div>
        <v-container fluid fill-height full-width>
            <v-layout align-center justify-center>
                <v-flex xs12 sm10>
                    <v-card class="elevation-12">
                        <v-toolbar color='default'>
                            <v-toolbar-title>{{ searchFormTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items v-if="addForm">
                                <v-btn flat v-on:click="formMode = 'Add';formDialog = true"><v-icon>add</v-icon></v-btn>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" v-on:click="loadAccounts"><v-icon>refresh</v-icon> Refrescar</v-btn>
                            </v-layout>
                            <!--<v-form id="search-form" name="search-form" v-bind="searchForm" v-on:submit.prevent="search">
                                <div v-for="(input, index) in searchFormInputs">
                                    <div v-if="input.inputType == 'textfield'">
                                        <v-text-field v-bind="input" v-model="input.model"></v-text-field>
                                    </div>
                                </div>
                            </v-form>
                            <br />-->
                            <v-card>
                                <!--<v-toolbar>-->
                                <!--<v-toolbar-title>{{ tableTitle }}</v-toolbar-title>-->
                                <!--<v-spacer></v-spacer>-->
                                <!--<v-text-field v-model="searchTerm"
                                              append-icon="filter_list"
                                              label="Buscar">
                                </v-text-field>-->
                                <!--</v-toolbar>-->
                                <v-card-text>
                                    <v-text-field v-model="searchTerm"
                                                  append-icon="search"
                                                  label="Buscar"
                                                  single-line
                                                  hide-details></v-text-field>
                                    <v-data-table :headers="headers"
                                                  :items="rows"
                                                  :loading="loading"
                                                  :search="searchTerm"
                                                  no-data-text="No hay datos disponibles aun por favor espere mientras se cargan..."
                                                  rows-per-page-text="Filas por página"
                                                  :rows-per-page-items='[5,10,20,25,{"text":"Todos","value":-1}]'
                                                  class="elevation-6">
                                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                        <template slot="items" slot-scope="props">
                                            <td v-text="props.item.Fullname"></td>
                                            <td v-text="props.item.UserName"></td>
                                            <td v-text="props.item.Email"></td>
                                            <td v-text="props.item.Role"></td>
                                            <td>
                                                <!--<v-btn color="default" fab small v-on:click="view(props.item.Id, $event)"><v-icon>fa fa-eye</v-icon></v-btn>-->
                                                <v-btn color="primary" fab small v-on:click="edit(props.item.Id, $event)"><v-icon>edit</v-icon></v-btn>
                                                <v-btn color="error" fab small v-on:click="LockUnlockUserAccount(props.item.Id, props.item.LockoutEnabled, $event, props)" title="Blockear/Desblockear"><v-icon v-html="props.item.LockoutEnabled ? 'lock': 'lock_open'"></v-icon></v-btn>
                                                <!--<v-btn color="warning" fab small v-on:click="copy(props.item.Id, $event)"><v-icon>fa fa-copy</v-icon></v-btn>
                                                <v-btn color="error" fab small v-on:click="del(props.item.Id, $event)"><v-icon>fa fa-remove</v-icon></v-btn>-->
                                            </td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            Su búsqueda por "{{ searchTerm }}" no encontro resultados.
                                        </v-alert>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <!--Form Dialog-->
        <v-layout row justify-center>
            <v-dialog v-model="formDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon v-on:click="close">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn :disabled="!valid" flat v-on:click="submit"><v-icon>save</v-icon></v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text>
                        <span>Todos los campos son requeridos.</span>
                        <v-form id="input-form" name="input-form" v-model="valid" ref="form" v-bind="form" :action="'/' + form.action + '/' + formMode" lazy-validation>
                            <v-layout row wrap>
                                <v-flex sm4>
                                    <div v-for="(input, index) in formInputs">
                                        <div v-if="formMode != 'Add' && (input.name == 'Password' || input.name == 'Fullname' || input.name == 'UserName')">
                                            <!-- Don't Do Anything -->
                                        </div>
                                        <div v-else-if="input.inputType == 'textfield'">
                                            <v-text-field v-bind="input" v-model="input.model"></v-text-field>
                                        </div>
                                        <div v-else-if="input.inputType == 'hidden'">
                                            <input type="hidden" v-bind="input" v-model="input.model" />
                                        </div>
                                        <div v-else-if="input.inputType == 'select'">
                                            <v-select v-bind="input" v-model="input.model" :items="input.items"></v-select>
                                        </div>
                                        <div v-else-if="input.inputType == 'autocomplete'">
                                            <v-autocomplete v-bind="input" v-model="input.model" :items="input.items"></v-autocomplete>
                                        </div>
                                        
                                        <div v-else-if="input.inputType == 'nativeselect'">
                                            <template v-if="input.name == 'Role'">
                                                <NativeSelect v-bind="input"
                                                              v-model="input.model">
                                                </NativeSelect>
                                            </template>
                                            <template v-else-if="input.name == 'REGION_NAME'">
                                                <NativeSelect v-show="formInputs[1].model == 'Graduados' || formInputs[1].model == 'Estadisticos'"
                                                              v-bind="input"
                                                              v-model="input.model">
                                                </NativeSelect>
                                            </template>
                                        </div>
                                        <div v-else-if="input.inputType == 'checkbox'">
                                            <v-checkbox v-bind="input" v-model="input.model"></v-checkbox>
                                        </div>
                                        <div v-else-if="input.inputType == 'switch'">
                                            <v-checkbox v-bind="input" v-model="input.model"></v-checkbox>
                                        </div>
                                        <div v-else-if="input.inputType == 'radio'">
                                            <v-radio-group v-model="input.model" :mandatory="true">
                                                <div v-for="(radio, index) in input.radios">
                                                    <v-radio v-bind="radio"></v-radio>
                                                </div>
                                            </v-radio-group>
                                        </div>
                                        <div v-else>
                                            <v-text-field v-bind="input" v-model="input.model"></v-text-field>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
    import script from './script'
    export default script
</script>


// WEBPACK FOOTER //
// src/components/account/index/component.vue